module.exports = __webpack_public_path__ + "static/media/IMG_3053.02991dee.PNG";